import { render, staticRenderFns } from "./PeopleParent.vue?vue&type=template&id=e4fcba58&"
import script from "./PeopleParent.vue?vue&type=script&lang=js&"
export * from "./PeopleParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports